
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_744_10395)"}},[_c('path',{attrs:{"d":"M16.335 7.124c0-1.103-.897-2-2-2h-12c-1.103 0-2 .897-2 2v7c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2v-7z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.085 2.624h-11.5a.748.748 0 00-.75.75c0 .416.334.75.75.75h11.5c.416 0 .75-.334.75-.75a.748.748 0 00-.75-.75zm-1.5-2.5h-8.5a.748.748 0 00-.75.75c0 .416.334.75.75.75h8.5c.416 0 .75-.334.75-.75a.748.748 0 00-.75-.75z","fill":"#89BCF9"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_744_10395"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5)","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    